import "./HomeError.css";

export default function HomeError({onRetry}){

    return(

        <section className="home-error">

            <h2>

                خطا در دریافت اطلاعات صفحه

            </h2>

            <button

                onClick={onRetry}

            >

                تلاش مجدد

            </button>

        </section>

    );

}